import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function arrangementsAdd(props: WosIconProps) {
  const { className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 721.1 722.5"
      fill="currentColor"
      className={className}
    >
      <path d="M412.7,551.05c-18.39,.83-34.1-14.88-34.21-34.21,.1-19.32,15.81-35.03,34.21-34.21l97.24,.1,.83-98.17c.1-19.32,15.81-35.03,34.21-34.21,20.25-.83,35.96,14.88,34.21,34.21l.83,96.31,97.24,1.76c20.25-.83,35.96,14.88,34.21,34.21,1.76,19.32-13.95,35.03-34.21,34.21l-97.24,1.76-.83,96.31c1.76,19.32-13.95,35.03-34.21,34.21-18.39,.83-34.1-14.88-34.21-34.21l-.83-98.17-97.24,.1h0Z" />
      <g>
        <path d="M309.49,432.92H28.67c-14.09,0-25.53-10.7-25.53-23.89V26.79C3.14,13.61,14.58,2.9,28.67,2.9H309.49c14.09,0,25.53,10.7,25.53,23.89V409.03c0,13.19-11.44,23.89-25.53,23.89Z" />
        <path d="M309.49,719.6H28.67c-14.09,0-25.53-10.7-25.53-23.89v-191.12c0-13.19,11.44-23.89,25.53-23.89H309.49c14.09,0,25.53,10.7,25.53,23.89v191.12c0,13.19-11.44,23.89-25.53,23.89Z" />
        <path d="M692.43,241.8H411.61c-14.09,0-25.53-10.7-25.53-23.89V26.79c0-13.19,11.44-23.89,25.53-23.89h280.82c14.09,0,25.53,10.7,25.53,23.89V217.91c0,13.19-11.44,23.89-25.53,23.89Z" />
      </g>
    </svg>
  );
}

export default arrangementsAdd;
